import "./PagesToolsetView.styl";
import { createJsonbTableEditor } from "../_resources/jsonbTableEditor.js";
import { getSupaPageDatasources } from "../_resources/supa-helpers.js";

export default function ({ dom, message, filePicker }) {
  let editor = null;

  const render = async (pageId, base_url, datasourcesFallback, hasPageEditAccess) => {
    // Always re-fetch datasources from supabase so newly added ones appear without a page refresh
    let datasources = datasourcesFallback;
    const { ok, error } = await getSupaPageDatasources(pageId);
    if (!error) datasources = ok;

    const possibleDSIDs = datasources ? datasources.map(ds => ds.ds_id) : [];
    const possibleTransitionValues = ["select", "show", "time"];
    const possibleSubcomponents = ["ExtApiMap", "BubbleChart"];

    const possibleToolTypes = [
      "BubbleChart",
      "BubbleChartSVG",
      "BarRank",
      "BubbleMap",
      "LineChart",
      "MountainChart",
      "BubbleMap",
      "PopByAge",
      "Spreadsheet",
      "ExtApiMap",
      "Combo",
    ]
    const possibleToolVariations = ["Base", "ClickMap"];
    const possibleMainMarkers = ["bubble", "bar", "line", "mountain", "pyramid", "spreadsheet"];

    console.log("Datasources for toolset editor:", possibleDSIDs);

    editor = createJsonbTableEditor({
      dom,
      heading: "Toolset",
      message,
      table: 'pages',
      recordId: pageId,
      fieldName: 'toolset',
      base_url,
      headers: ["Image", "id and 文 Name", "This part is confusing!", "Datasources", "Transition", "Hide thumb",  "Icon", "Link"],
      columns: [
        {field: "image", type: "image", label: "Image", required: false, columnIndex: 0, comment: `Image for See-Also ribbon: uploaded file, global https url or asset/path`},
        {field: "id", type: "text", label: "id", required: true, columnIndex: 1},
        {field: "title", type: "text", label: "文 Name", required: false, columnIndex: 1, comment: "set directly here or use a translated 文 Text"},
        {field: "tool", type: "options", label: "Tool", values: possibleToolTypes, required: false, columnIndex: 2},
        {field: "toolVariation", type: "options", label: "Variation", values: possibleToolVariations, required: false, columnIndex: 2},
        {field: "toolComponents", type: "textarray", label: "Parts for combo", values: possibleSubcomponents, required: false, columnIndex: 2},
        {field: "mainMarker", type: "options", label: "Main Marker", values: possibleMainMarkers, required: false, columnIndex: 2},
        {field: "dataSources", type: "textarray", label: "Datasources", values: possibleDSIDs, required: false, columnIndex: 3},
        {field: "transition", type: "textarray", label: "Transition", values: possibleTransitionValues, required: false, columnIndex: 4},
        {field: "hideThumbnail", type: "boolean", label: "Hide thumbnail", required: false, columnIndex: 5},
        {field: "icon", type: "image", label: "icon", required: false, columnIndex: 6, comment: `Icon for chart switcher: uploaded file, global https url or asset/path or ICON_ID from a <a href="https://github.com/Gapminder/tools-page/blob/main/src/app/core/icons.js">known list</a>`},
        {field: "url", type: "url", label: "Link", displayshort: 0, required: false, columnIndex: 7, comment: "sometimes we just want a card with a link elsewhere, see Dollar Street card on gapminder.org/tools"},
      ],
      allowReorder: hasPageEditAccess,
      allowAdd: hasPageEditAccess,
      allowEdit: hasPageEditAccess,
      allowDelete: hasPageEditAccess,
      filePicker
    });

    editor.load();
  };

  return { render };
}

